import { ArrayParam, useQueryParam, withDefault } from 'use-query-params';
import useCurrentUser from 'hooks/useCurrentUser';

export const SHIFT_TYPE_OPTIONS = [
  { value: '1099', label: '1099' },
  { value: 'W2', label: 'W2' },
];

interface IUseShiftType {
  shiftType: string[];
  setShiftType: (schedule: string[]) => void;
  clearShiftType: () => void;
  hasShiftType: boolean;
  shouldDisplay: boolean;
}

export const useShiftType = (): IUseShiftType => {
  const { currentUser } = useCurrentUser();
  const shouldDisplay =
    currentUser?.professional?.w2_eligible && currentUser?.professional?.w2_enabled;

  const [job_type, setQuery] = useQueryParam(
    'job_type',
    withDefault(ArrayParam, shouldDisplay ? [] : ['1099']),
  );

  const clearShiftType = () => setQuery(undefined, 'replaceIn');

  const setShiftType = (shiftType: string[]) =>
    shiftType?.length ? setQuery(shiftType, 'replaceIn') : clearShiftType();

  return {
    shiftType: job_type,
    setShiftType,
    clearShiftType,
    shouldDisplay,
    hasShiftType: shouldDisplay && !!job_type?.length,
  };
};

export default useShiftType;
